/**
 * Chaves usadas em localStorage/sessionStorage.
 * Centralizado para evitar strings hardcoded e facilitar refatoração.
 */
export const StorageKeys = Object.freeze({
  BackendAccessToken: "backendAccessToken",
});
